import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Star } from "lucide-react";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import backgroundImage from "../../assets/1.webp"; // Import the image

interface Reviewer {
  name: string;
  role: string;
  avatar?: string;
}

interface Testimonial {
  text: string;
  reviewer: Reviewer;
}

const testimonials: Testimonial[] = [
  {
    text: "This is a heritage property. Well maintained. The staff here are very warm and friendly. And yes with the rumours circulating of this property being haunted is an absolute hoax. The best part of this property is its location.",
    reviewer: { name: "Samrat Sarkar", role: "Guest", avatar: "" },
  },
  {
    text: "One of the Best Hotels in Darjeeling. Prime location is the plus point. Rooms give the heritage look and view from the window was amazing.",
    reviewer: { name: "Aakash Sarma", role: "Guest", avatar: "" },
  },
  {
    text: "The architecture and location is too good. The staff is also very well behaved and polite. Strongly recommend staying here.",
    reviewer: { name: "Samiran Pal", role: "Guest", avatar: "" },
  },
];

const Stars: React.FC<{ count?: number }> = ({ count = 5 }) => (
  <div className="flex items-center justify-center gap-1" style={{ color: '#C0B283' }} aria-label={`${count} star rating`}>
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-current" />
    ))}
  </div>
);

const ReviewerChip: React.FC<Reviewer> = ({ name, role, avatar }) => (
  <div className="mt-6 flex items-center justify-center gap-4 group">
    <div>
      <div className="font-semibold leading-tight text-white">{name}</div>
    </div>
  </div>
);

const SectionShell: React.FC<React.PropsWithChildren<{ bg: string }>> = ({ bg, children }) => (
  <section className="relative w-full overflow-hidden" data-aos="fade-up">
    <img
      src={bg}
      alt="Background"
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-black/60" />
    <div className="relative mx-auto max-w-6xl px-6 py-20 md:py-24 lg:py-28">
      {children}
    </div>
  </section>
);

const TitleBlock: React.FC = () => (
  <div className="mb-6 md:mb-8 text-center" data-aos="fade-up">
    <div className="mb-2 flex items-center justify-center gap-2 text-[12px] tracking-[0.2em] text-beige/80">
      <span className="inline-block h-1 w-1 rounded-full bg-beige"></span>
      <span>TESTIMONIALS</span>
    </div>
    <h2 className="text-3xl font-semibold text-white sm:text-4xl md:text-[40px] md:leading-tight">
      What Our Clients Say
    </h2>
  </div>
);

const TestimonialSlide: React.FC<Testimonial> = ({ text, reviewer }) => (
  <div className="px-4 text-center">
    <div className="max-w-3xl mx-auto text-white" data-aos="fade-up">
      <Stars />
      <p className="mt-3 text-lg leading-relaxed text-white md:text-xl">
        “{text}”
      </p>
    </div>
    <ReviewerChip {...reviewer} />
  </div>
);

const OrientalTestimonial: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth < 768);
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: !isMobile,
  };

  return (
    <div className="relative testimonial-carousel">
      <SectionShell bg={backgroundImage}>
        <TitleBlock />
        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <TestimonialSlide key={index} {...testimonial} />
          ))}
        </Slider>
      </SectionShell>
    </div>
  );
};

export default OrientalTestimonial;
